module.exports = __webpack_public_path__ + "static/lighting-table-selected-all-a8fac4ae7bb5b06a3433471c7ad2ba09.png";